import * as types from './types';

const INITIAL_STATE = {
  report: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.UNCLOSED_DATES_REPORT_GET_REPORT:
      return { ...state, report: payload };

    case types.UNCLOSED_DATES_REPORT_FETCH_ERROR:
      return {
        ...state,
        error: payload,
      };

    case types.UNCLOSED_DATES_REPORT_FETCHING:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/uncloseddates/state/uncloseddatesreport/reducer.js